import React from "react";

export default function Press() {
  return (
    <div className="max-w-3xl mx-auto py-16 px-4">
      <h1 className="text-4xl font-bold mb-4 text-gradient bg-gradient-to-r from-pink-500 via-indigo-500 to-purple-500 bg-clip-text text-transparent">Press & Media</h1>
      <p className="text-lg text-gray-700 mb-6">For media inquiries, interviews, or press materials, please contact <a href="mailto:press@inflatein.com" className="text-indigo-600 underline">press@inflatein.com</a>.</p>
      <h2 className="text-2xl font-semibold mt-8 mb-2">Press Releases</h2>
      <ul className="list-disc pl-6 text-gray-600 mb-4">
        <li>Inflatein AI Studio launches Pro Credits for creators (July 2025)</li>
        <li>Inflatein AI Studio reaches 100,000 users (May 2025)</li>
      </ul>
      <h2 className="text-2xl font-semibold mt-8 mb-2">Media Kit</h2>
      <p className="text-gray-600">Download our <a href="/brand-logo.svg" className="text-indigo-600 underline">logo</a> and <a href="/docs" className="text-indigo-600 underline">brand guidelines</a>.</p>
    </div>
  );
}
